import { Button } from '@pmi/dsm-react';
import { useEffect, useState } from 'react';
import Overlay from '../../../shared/components/Overlay';
import { useSelector } from 'react-redux';
import styles from '../logs.module.scss';
import { useGetEnrollmentLogsQuery } from '../apiSlice';
import EnrollmentLogsTable from './EnrollmentLogsTable';
import { EnrollmentLog } from '../models';
import { accountSelector } from '../../../shared/store/shared/accountSlice';

export default function EnrollmentLogs() {
  const { currentAccountId } = useSelector(accountSelector);
  const [cToken, setCtoken] = useState<string>('');
  const [hasMore, setHasMore] = useState(false);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const { data: logsData, isLoading } = useGetEnrollmentLogsQuery(
    {
      accountId: currentAccountId,
      continuationToken: cToken,
    },
    { refetchOnMountOrArgChange: true, skip: hasLoaded },
  );
  const [storedData, setStoredData] = useState<EnrollmentLog[]>([]);

  useEffect(() => {
    if (logsData?.items?.length > 0 && !hasLoaded) {
      // set hasLoaded to true to avoid double rerender
      setHasLoaded(true);
      setStoredData([...storedData, ...logsData.items]);
      if (logsData?.continuationToken) {
        setCtoken(logsData?.continuationToken);
        setHasMore(true);
      } else {
        // reset states if there is no continuationToken
        setHasMore(false);
      }
    }
  }, [hasLoaded, logsData]);

  const handleLoadMore = () => {
    // set hasLoaded to false when clicking load more
    setHasLoaded(false);
  };

  return (
    <>
      <h5 className=" fw-normal fs-4 my-3">
        <strong className="fw-bold">
          <span>Enrollment Logs</span>
        </strong>
      </h5>

      <div className={styles['card-container']}>
        {!isLoading && storedData?.length === 0 && (
          <p className={`${styles['no-log-msg']}`}>No logs available</p>
        )}

        {storedData?.length !== 0 && <EnrollmentLogsTable logs={storedData} />}
      </div>
      {hasMore && (
        <div className="text-center pt-3">
          <Button
            variant="primary"
            onClick={handleLoadMore}
            titleText="Load More"
          />
        </div>
      )}
      <Overlay
        variant="PMIOverlay"
        global
        animated
        fade
        iconColor="brand-dark"
        overlayColor="black"
        overlayOpacity={1}
        show={isLoading}
      />
    </>
  );
}
